import { render, staticRenderFns } from "./KioskFooter.vue?vue&type=template&id=c193e0fe&"
import script from "./KioskFooter.vue?vue&type=script&lang=js&"
export * from "./KioskFooter.vue?vue&type=script&lang=js&"
import style0 from "./KioskFooter.vue?vue&type=style&index=0&id=c193e0fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports